"use client"

import React from 'react';

export default function Promo () {
    return <div className="promo-container hide bg-primary padding text-center">
        <div className="promo-wrapper">
            <p className="no-margin secondary">Subscriptions from £17.50 per month - Get Started</p>
        </div>
    </div>
}